import { Col, Form, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { fetchEndpointGroups, fetchEndpoints } from "../../../common/functions";

export default function CredentialRotationPolicy() {
  const [loading, setLoading] = useState(false);
  const [endpoints, setEndpoints] = useState([]);
  const [endpointGroups, setEndpointGroups] = useState([]);
  const [form] = Form.useForm();

  const protocolPortMap = {
    SSH: 22,
    RDP: 3389,
    VNC: 5900,
    Telnet: 22,
  };

  useEffect(() => {
    fetchEndpoints({}).then((instances) => {
      setEndpoints(
        instances.map((instance) => ({
          id: instance.instanceId,
          text: instance.hostName,
          publicIp: instance.publicIp,
        })),
      );
    });

    fetchEndpointGroups({}).then(({ groups }) => {
      setEndpointGroups(groups);
    });
  }, []);

  return (
    <Spin spinning={loading}>
      <Row className="content-conatiner">
        <Col>
          <Row>
            <Col>
              <h2 className="title">Credential Rotation Policy</h2>
            </Col>
          </Row>
        </Col>
      </Row>
    </Spin>
  );
}
